import React from 'react';
import { connect } from 'react-redux';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import { formatarReal } from '../../util/numberUtil';
import ReactTooltip from 'react-tooltip';
import Autorizacao from '../../security/Autorizacao';
import {
  PERFIL_ADMIN,
  getAdminEmpresa,
  getGestorEmpresa,
} from '../../security/securityContext';
import selecionarPedido from '../../actions/pedido/selecionarPedido';
import buscarHistoricosReservas from '../../actions/pedido/buscarHistoricosReservas';
import limparHistoricosReservas from '../../actions/pedido/limparHistoricosReservas';

export const Cabecalho = () => (
  <thead>
    <tr>
      <th className="vx-hist-th">Data e Hora</th>
      <th className="vx-hist-th">Situação</th>
      <th className="vx-hist-th">Usuário</th>
      <th className="vx-hist-th">Responsável</th>
      <th className="vx-hist-th">Observação</th>
      <th className="vx-hist-th">Estorno</th>
    </tr>
  </thead>
);

export const CabecalhoReserva = () => (
  <thead>
    <tr>
      <th className="vx-hist-th">Data e Hora</th>
      <th className="vx-hist-th">Situação</th>
      <th className="vx-hist-th">Usuário</th>
      <th className="vx-hist-th">Responsável</th>
      <th className="vx-hist-th">Observação</th>
      <th className="vx-hist-th">Reserva Nº</th>
    </tr>
  </thead>
);

export class ModalHistoricoPedido extends React.Component {

  componentDidUpdate(prevProps) {
    if (this.props.pedido && prevProps.pedido !== this.props.pedido) {
      this.props.buscarHistoricosReservas(
        this.props.pedido.id,
        this.props.empresaSelecionada.id
      )
    }
  }

  limpar() {
    this.props.limparHistoricosReservas();
    this.props.selecionarPedido(null);
  }

  possuiReservasCanceladas() {
    return this.props.pedido.reservas.filter(r => r.situacaoReserva === 'CANCELADO').length > 0;
  }

  possuiHistoricoPedidoCancelado(historico) {
    return this.possuiReservasCanceladas() &&
      (historico.situacaoPedido === 'CANCELADO' || historico.situacaoPedido === 'CANCELADO_REMARCADO_PARCIALMENTE' ||
        historico.situacaoPedido === 'CANCELADO_REMARCADO')
  }

  exibirAnotacaoInternaReserva() {
    const reservasCanceladas = this.props.pedido.reservas.filter(it => it.situacaoReserva == 'CANCELADO')
    return (
      <span className="vx-gp-tooltip-trigger">
        <a data-tip data-for="anotacao-interna">
          <i className="material-icons">info</i>
        </a>
        <ReactTooltip id="anotacao-interna" type="dark" effect="solid">
          Anotação interna: {reservasCanceladas.map(it => it.observacao).join(' | ')}
        </ReactTooltip>
      </span>
    )
  }

  exibirHistorico() {
    if (this.props.pedido && this.props.pedido.historicos) {
      return (
        <div className="vx-hist-wrap">
          <table className="vx-hist-table">
            <Cabecalho />
            <tbody>
              {this.props.pedido.historicos.map(historico => (
                <tr key={`${historico.cod}-${historico.dataHora}`}>
                  <td className="vx-hist-td">{historico.dataHora}</td>
                  <td className="vx-hist-td">
                    <span className="vx-hist-badge">{historico.descricaoSituacao}</span>
                  </td>
                  <td className="vx-hist-td">{capitalizarTodasPrimeirasLetras(historico.nomeUsuario)}</td>
                  <td className="vx-hist-td">
                    {capitalizarTodasPrimeirasLetras(`${this.props.pedido.idUsuarioEmpresaResponsavel}-${this.props.pedido.usuarioEmpresaResponsavel}`)}
                  </td>
                  <td className="vx-hist-td">
                    {historico.observacao || <span style={{color: '#bbb'}}>—</span>}
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                      getGestorEmpresa(this.props.empresaSelecionada.id),
                      getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                      {this.possuiHistoricoPedidoCancelado(historico) ? this.exibirAnotacaoInternaReserva() : ''}
                    </Autorizacao>
                  </td>
                  <td className="vx-hist-td">
                    {this.possuiHistoricoPedidoCancelado(historico)
                      ? <strong style={{color: '#FF6A00'}}>{formatarReal(this.props.pedido.valorEstorno)}</strong>
                      : <span style={{color: '#bbb'}}>—</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
    }
    return ''
  }

  exibirAnotacaoHistoricoReserva(idReserva, observacao) {
    if (observacao) {
      return (
        <span className="vx-gp-tooltip-trigger">
          <a data-tip data-for={`obs-res-${idReserva}`}>
            <i className="material-icons">info</i>
          </a>
          <ReactTooltip id={`obs-res-${idReserva}`} type="dark" effect="solid">
            {observacao}
          </ReactTooltip>
        </span>
      )
    }
    return <span style={{color: '#bbb'}}>—</span>
  }

  exibirHistoricosReservas() {
    const historicos = this.props.historicosReservas
    if (!historicos || historicos.length === 0) {
      return <p style={{color: '#999', padding: '10px 0'}}>Nenhum histórico de reserva encontrado.</p>
    }

    const porReserva = historicos.reduce((acc, hr) => {
      if (!acc[hr.idReserva]) acc[hr.idReserva] = []
      acc[hr.idReserva].push(hr)
      return acc
    }, {})

    return Object.keys(porReserva).map(idReserva => (
      <div key={`reserva-${idReserva}`} style={{marginBottom: 14}}>
        <div className="vx-hist-reserva-badge">
          <span className="material-icons">confirmation_number</span>
          Reserva #{idReserva}
        </div>
        <div className="vx-hist-wrap">
          <table className="vx-hist-table">
            <CabecalhoReserva />
            <tbody>
              {porReserva[idReserva].map((hr, idx) => (
                <tr key={`hr-${idReserva}-${idx}`}>
                  <td className="vx-hist-td">{hr.dataHora}</td>
                  <td className="vx-hist-td"><span className="vx-hist-badge">{hr.descricaoSituacao}</span></td>
                  <td className="vx-hist-td">{capitalizarTodasPrimeirasLetras(hr.nomeUsuario)}</td>
                  <td className="vx-hist-td">
                    {capitalizarTodasPrimeirasLetras(`${this.props.pedido.idUsuarioEmpresaResponsavel}-${this.props.pedido.usuarioEmpresaResponsavel}`)}
                  </td>
                  <td className="vx-hist-td">{this.exibirAnotacaoHistoricoReserva(idReserva, hr.observacao)}</td>
                  <td className="vx-hist-td">{idReserva}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    ))
  }

  render() {
    return (
      <div className="modal fade show" role="dialog"
           id="modalHistoricoPedido" aria-labelledby="modalHistoricoPedido" aria-hidden="true" data-backdrop="static">
        <div className="modal-dialog modal-info modal-xl modal-dialog-centered">
          <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>

            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">history</span>
                Histórico do Pedido
                {this.props.pedido
                  ? <span style={{fontWeight: 400, fontSize: '13px', opacity: .7}}> — Pedido #{this.props.pedido.id}</span>
                  : ''}
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal"
                      id="btnFecharmodalHistoricoPedido" aria-label="Fechar" onClick={() => this.limpar()}>
                <span className="material-icons">close</span>
              </button>
            </div>

            <div className="vx-modal-body">
              <div className="vx-hist-section-title">
                <span className="material-icons">receipt</span>
                Histórico do Pedido
              </div>
              {this.exibirHistorico()}

              <div className="vx-hist-section-title" style={{marginTop: 20}}>
                <span className="material-icons">confirmation_number</span>
                Histórico das Reservas
              </div>
              {this.exibirHistoricosReservas()}
            </div>

            <div className="vx-modal-footer">
              <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                      onClick={() => this.limpar()}>
                Fechar
              </button>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export function mapStateToProps(state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    pedido: state.pedido,
    historicosReservas: state.historicosReservas
  }
}

export default connect(mapStateToProps,
  {
    selecionarPedido,
    buscarHistoricosReservas,
    limparHistoricosReservas
  })(ModalHistoricoPedido)
